import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

import { DefaultHitsPerPage } from "@/components/Search/SearchResults/components/results/components/productsResults/components/resultsView/components/filters/components/productHitsPerPage/hitsPerPage.config";
import { AnySearchConfiguration } from "@/utils/search/types/searchConfiguration";

export const PREFIX_SEPARATOR = ".";
export const NUMERIC_FILTER_SEPARATOR = ":";
export const FACET_FILTER_SEPARATOR = ";";

// Configuration -> Route
export const DEFAULT_ROUTE: AnySearchConfiguration = {
    hitsPerPage: DefaultHitsPerPage,
    page: 0,
    sortBy: IndexSort.Default
};

// Route -> Configuration
export const NUMERIC_FILTER_REGEX = new RegExp(
    `(\\d+|\\*)${NUMERIC_FILTER_SEPARATOR}(\\d+|\\*)`
);
